module.exports = __webpack_public_path__ + "static/media/cq_apri_blu.180d9f70.svg";